import type { Candidate, SharedItem } from '@flobi/asset-library/share';
import { gatewayCall } from './gateway';

/**
 * The users-back sharing hub (SHARING-MODEL.md §4), as Artwork calls it. ONE file on
 * purpose: the hub is merged in parallel, and if a command name or a field moves at
 * merge, this is the only place to change.
 */

/** `sharing.people.search` — people, guests and departments in the workspace, server-side, ≤ 20. */
export async function searchPeople(workspaceId: string, q: string, opts: { limit?: number; signal?: AbortSignal } = {}): Promise<{ results: Candidate[] }> {
  const res = await gatewayCall<{ results?: Candidate[] }>('users', 'sharing.people.search', { workspaceId, q, limit: opts.limit ?? 10 }, { signal: opts.signal });
  return { results: Array.isArray(res?.results) ? res.results : [] };
}

/** `sharing.request.create` — "Request edit access". */
export async function requestAccess(input: { app: string; resourceType: string; resourceId: string; role: string; message?: string; acceptContextId?: string }) {
  const res = await gatewayCall<{ sentTo?: { name?: string }; managers?: { name?: string }[] }>('users', 'sharing.request.create', input);
  const name = res?.sentTo?.name || res?.managers?.[0]?.name;
  return name ? { sentTo: { name } } : undefined;
}

/** `sharing.sharedWithMe.list` — every workspace, filtered to one app. */
export async function listSharedWithMe(input: { app?: string; cursor?: string } = {}): Promise<{ items: SharedItem[]; nextCursor: string | null }> {
  const res = await gatewayCall<{ items?: SharedItem[]; nextCursor?: string | null }>('users', 'sharing.sharedWithMe.list', { ...input });
  return { items: Array.isArray(res?.items) ? res.items : [], nextCursor: res?.nextCursor ?? null };
}

/** `sharing.invite.setup` — what the InviteSheet draws. No workspace named = the session's. */
export async function inviteSetup(workspaceId?: string) {
  return gatewayCall<Record<string, unknown>>('users', 'sharing.invite.setup', workspaceId ? { workspaceId } : {});
}
